var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo-web';
                    var viewUrl = 'sprite.svg#view-logo-web';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?logo-web#logo-web';
                            viewUrl = 'sprite.svg?logo-web#view-logo-web';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };